// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__21RMS","title":"Info_title__2_8K6","selects":"Info_selects__cV5-f","requiredAsterisk":"Info_requiredAsterisk__2WAFg"};